import Component from 'vue-class-component';
import GridFilter from './GridFilter';

@Component
export default class GridFilterContains extends GridFilter {
}
